import { isClientSide } from "~/helpers/general";
import type { RecaptchaAction } from "~/types";
import type { NitroFetchRequest } from "nitropack";
import { stripUrlQuery } from "./routing";

export function getRecaptchaToken(action: RecaptchaAction) {
  return new Promise<string>(async res => {
    await setup();
    window.grecaptcha.enterprise.ready(async () => {
      const token = await window.grecaptcha.enterprise.execute(getKey(), { action });
      res(token);
    });
  });
}

export function getCaptchaAction(route: NitroFetchRequest): RecaptchaAction {
  switch (stripUrlQuery(route as string)) {
    case '/api/save-form': return 'save_form';
    case '/api/payment-intent': return 'payment_intent';
    case '/api/create-paypal-order': return 'create_paypal_order';
    case '/api/send-contact-message': return 'send_contact_msg';
    case '/api/send-resume-url': return 'send_resume_url';
    case '/api/order-status': return 'get_order_status';
    case '/api/upload-photo': return 'upload_photo';
  }
  throw new Error(`route ${route} doesn't have a matching captcha action.`);
}

function setup() {
  if (!isSetupNeeded()) return;
  return new Promise(resolve => {
    useHead({
      script: [{
        src: 'https://www.google.com/recaptcha/enterprise.js?render=' + getKey(),
        defer: true,
        onload: resolve
      }]
    });
  });
}

function isSetupNeeded() {
  return isClientSide() && !window.grecaptcha;
}

function getKey() {
  return useRuntimeConfig().public.recaptchaSitekey;
}